import React from 'react';
import { useIsMutating } from '@tanstack/react-query';
import { Loader2 } from 'lucide-react';

interface PendingOperationsIndicatorProps {
  floorPlanId: string;
}

export function PendingOperationsIndicator({ floorPlanId }: PendingOperationsIndicatorProps) {
  // Count mutations for circuits
  const circuitMutations = useIsMutating({
    mutationKey: ['createCircuitWithFixtures'],
  });
  
  // Count mutations for fixtures
  const fixtureMutations = useIsMutating({
    predicate: (mutation) => {
      const key = mutation.options.mutationKey;
      return Array.isArray(key) && key.includes('fixtures');
    },
  });
  
  const totalPending = circuitMutations + fixtureMutations;
  
  if (totalPending === 0) return null;
  
  return (
    <div className="absolute bottom-[env(safe-area-inset-bottom,16px)] right-4 z-50 pointer-events-none"
         style={{ marginBottom: 'max(16px, env(safe-area-inset-bottom))' }}>
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg border p-3 flex items-center gap-3">
        <Loader2 className="h-4 w-4 animate-spin text-blue-500" />
        <div className="text-sm">
          <p className="font-medium">
            {totalPending} operation{totalPending > 1 ? 's' : ''} in progress
          </p>
          <p className="text-muted-foreground text-xs">
            Changes are being saved...
          </p>
        </div>
      </div>
    </div>
  );
}